const tbs_model_vo_TeamManager = function() {
}

tbs_model_vo_TeamManager.prototype = {
    /* The view object name */
    name: 'teamManager',
    /* The view object instance */
    view: {
        manage: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchTeam',
            basePath: 'data.team',
            rule: {
                team: '$id,matchId,name,badge',
                playerList: '$players'
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'DeleteBMMatchTeamPlayer',
            basePath: '',
            rule: {
                id: 'id',
                matchId: 'matchGroupId'
            }
        },
    },
    renderTeam: function(id, matchId, name, badge) {
        return {
            id: id,
            matchGroupId: matchId,
            name: name,
            logoUrl: badge
        }
    },
    renderPlayerList: function(players) {
        const playerList = []
        for (let i = 0; i < players.length; i++) {
            let player = players[i]
            playerList.push({
                id: player.id,
                name: player.trueName,
                num: player.number,
                logoUrl: player.avatar
            })
        }
        return playerList
    },
}

module.exports = tbs_model_vo_TeamManager